export default __webpack_public_path__ + "static/media/vacanted.7ffd4db1.png";